import { useUsersStore } from '@/stores/index.js'

export default {

  hasAccessTo: (state) => (permissionName) => {
    const usersStore = useUsersStore()
    const access = state.adminModulesPermissions.some(permission => permission.name === permissionName)
    return usersStore.current ? access : false

  },
  getAccessPermissionsTo: (state) => (permissionName) => {
    return state.adminModulesPermissions.filter(permission => permission.name === permissionName)
  },
  havePermissions (state) {
    const excludedModules = ['routines', 'galleries'];

    return state.adminModulesPermissions?.some(permission =>
      !excludedModules.includes(permission.name)
    ) ?? false
  },
    getFranchiseIdListNotOrg: (state) => (permissionName) => {
    const usersStore = useUsersStore()
    const permissions = state.adminModulesPermissions?.filter(p => p.name === permissionName)
    if (usersStore.currentIsOrganizationAdmin || permissions.some(p => p.subpermission === 'all')) return null
    const nonAllPerms = permissions?.filter(p => p.subpermission !== 'all').map(p => p.franchiseId)
    const franchisesIds = new Set([...usersStore.userFranchisesAdmin, ...nonAllPerms])
    return Array.from(franchisesIds)
  }
}
